import React, { Component } from 'react'
import intl from 'react-intl-universal'
import PropTypes from 'prop-types'
import { inject, observer, PropTypes as MobxTypes } from 'mobx-react'
import { resetPassword } from '../api'
import Input from './Input'
import 'formdata-polyfill'
import { parse } from 'query-string'
import object_value from '../api/object_value'
import { NotificationManager } from 'react-notifications'
import { withRouter } from 'react-router-dom'

@inject('user', 'modals')
@observer
class ResetPasswordForm extends Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      form_class: 'b-form',
      password: null,
      status: '',
      message: ''
    }
  }

  // Enable browser form validation on any input change
  makeValidationVisible = () => {
    // Make validation errors visible
    if (this.state.form_class === 'b-form') {
      this.setState({form_class: this.state.form_class + ' b-form_allow-browser-validation'})
    }
  }

  handlePasswordInput = async (event) => {
    await this.setState({password: event.target.value || null})
  }

  handleRepeatPasswordInput = async (event) => {
    await this.setState({repeat_password: event.target.value || null})
  }

  passwordsMismatch = () => this.state.password !== this.state.repeat_password

  sumbitIsDisadbled = () => (!this.state.password || this.passwordsMismatch())

  handleChange = async (event) => {
    console.log('handleChange()')
    await this.setState({status: '', form_edited: true})
  }

  // Elegant way of binding handler to (this) without `constructor(){ super() }`
  handleSubmit = async (event) => {
    event.preventDefault()

    this.setState({status: 'loading'})

    const data = new FormData(event.target)
    // Display the key/value pairs
    console.log('handleSubmit() - data')
    for (let [key, val] of data.entries()) {
      console.log(key, val)
    }

    // Clean up
    data.delete('password_repeat')

    const token = this.props.reset_token
    console.log('handleSubmit() - token', token)

    let response = await resetPassword(data, {addedData: {token}})
    console.log('handleSubmit() - response', response)

    // Error
    if (!response.ok) {
      if (this.refs.ResetPasswordForm) { // Prevent a warning - https://stackoverflow.com/a/40969739
        this.setState({
          status: 'error',
          message: object_value(response, 'data.message', 'Error')
        })
      }

      return false
    }

    // Success
    if (this.refs.ResetPasswordForm) {
      this.setState({
        status: 'success',
        message: 'Password has been reset'
      })
    }
    NotificationManager.success('Password has been reset', 'Done', 5000)
    setTimeout(() => {
      this.props.history.push('/')
    }, 1000)
  }

  render () {
    return (
      <form ref="ResetPasswordForm"
            className={this.state.form_class}
            onChange={this.handleChange}
            onSubmit={this.handleSubmit}>

        <div className='b-form-row'>
          <div className='b-form-item b-form-item_x'>
            <Input className='b-form-item-input-text'
                   minLength={8}
                   type='password'
                   id='password'
                   name='password'
                   onChange={this.handlePasswordInput}
                   required={this.passwordsMismatch()} />
            <label className='b-form-item-label'
                   htmlFor='password'>
              {intl.get('New Password')}
            </label>
          </div>

          <div className={!this.passwordsMismatch()
            ? 'b-form-item b-form-item_x'
            : 'b-form-item b-form-item_x is_invalid'}>
            <Input className='b-form-item-input-text'
                   minLength={8}
                   type='password'
                   id='password_repeat'
                   name='password_repeat'
                   disabled={!this.state.password}
                   onChange={this.handleRepeatPasswordInput}  />
            <label className='b-form-item-label'
                   htmlFor='password_repeat'>
              {intl.get('Repeat new password')}
            </label>

            {this.passwordsMismatch() && this.state.form_edited &&
            <div className='b-form-item-input-message'>
              {intl.get('Passwords mismatch')}
            </div>}
          </div>
        </div>

        {this.state.status === 'loading' &&
        <div className='b-form-success'>{intl.get('Loading')}...</div>}

        {this.state.status === 'error' &&
        <div className='b-form-error'>{this.state.message}</div>}

        {this.state.status === 'success' &&
        <div className='b-form-success'>{this.state.message}</div>}

        {this.state.status !== 'success' &&
        <div className='b-form-row'>
          <button type='submit'
                  className='b-button b-button_primary b-button_x'
                  onClick={this.makeValidationVisible}
                  disabled={this.sumbitIsDisadbled()}>
            {intl.get('Submit')}
          </button>
        </div>}
      </form>
    )
  }
}

ResetPasswordForm.propTypes = {
  history: PropTypes.any,
  location: MobxTypes.objectOrObservableObject,
  modals: MobxTypes.observableObject
}

export default withRouter(ResetPasswordForm)



// WEBPACK FOOTER //
// ./src/components/ResetPasswordForm.js